import * as React from "react"
const FacebookLogoMoblie = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="#4F2E03"
      d="M12.758.25H.742A.743.743 0 0 0 0 .993v12.015a.742.742 0 0 0 .743.742h6.466V8.52H5.454V6.494h1.755V4.975a2.457 2.457 0 0 1 2.619-2.7 13.68 13.68 0 0 1 1.573.081V4.18h-1.073c-.851 0-1.013.405-1.013.992v1.303h2.025l-.263 2.025H9.315v5.251h3.443a.742.742 0 0 0 .742-.742V.993a.743.743 0 0 0-.742-.743Z"
    />
  </svg>
)
export default FacebookLogoMoblie
